import { isAdmin } from '../domain/user';
import { useUserQuery } from '../features/user/useUserQuery';

interface UserStatus {
  isTrial: boolean;
  isAfterTrial: boolean;
  isNoTouch: boolean;
  isTrialOrAfterTrial: boolean;
  isAdmin: boolean;
}

export const useUserStatus = (): UserStatus => {
  const { data: userData } = useUserQuery();
  const isTrial = userData?.isTrialAccount ?? false;
  const isAfterTrial = userData?.isAfterTrialAccount ?? false;
  const isNoTouch = userData?.isNoTouchAccount ?? false;

  const isTrialOrAfterTrial = isTrial || isAfterTrial;

  return { isTrial, isAfterTrial, isNoTouch, isTrialOrAfterTrial, isAdmin: isAdmin(userData) };
};
